module.exports = require("./sw.d.ts");